import React, {
  type ComponentType,
  type ReactNode,
  type ErrorInfo,
} from 'react';
import ErrorBoundary from './ErrorBoundary';

interface ErrorBoundaryOptions {
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
  level?: 'page' | 'component' | 'critical';
}

function withErrorBoundary<P extends object>(
  Component: ComponentType<P>,
  options: ErrorBoundaryOptions = {}
) {
  const WrappedComponent = (props: P) => (
    <ErrorBoundary {...options}>
      <Component {...props} />
    </ErrorBoundary>
  );

  WrappedComponent.displayName = `withErrorBoundary(${Component.displayName || Component.name})`;

  return WrappedComponent;
}

export default withErrorBoundary;
